export const FETCH_CUSTOMIZATION_REQUEST = 'FETCH_CUSTOMIZATION_REQUEST';
export const FETCH_CUSTOMIZATION_SUCCESS = 'FETCH_CUSTOMIZATION_SUCCESS';
export const FETCH_CUSTOMIZATION_FAILURE = 'FETCH_CUSTOMIZATION_FAILURE';